<h5>Course Evaluation</h5>
<ng-container *ngIf="course.userData.Evaluated">
  <app-dynamic-content [blocktitle]="'Course Evaluation Complete'"></app-dynamic-content>
</ng-container>
<ng-container *ngIf="!course.userData.Evaluated">
  <app-dynamic-content [blocktitle]="'Course Evaluation Intro'"></app-dynamic-content>
  <ng-container *ngIf="(evalQuestions$ | async) as evalQuestions; else loading">
    <form [formGroup]="evalForm" (submit)="submitEval(evalForm)">
      <div *ngFor="let question of evalQuestions; let q = index;">
        <strong>{{question}}</strong>
        <br />
        <select formControlName="eval_{{q + 1}}" required>
          <option *ngFor="let option of options; let i = index;" value="{{i == 0 ? '' : i}}">{{option}}</option>
        </select>
      </div>
      <div>
        <strong>Additional comments</strong>
        <br />
        <textarea formControlName="eval_comments"></textarea>
      </div>
      <button class="btn btn-success mb-5" [disabled]="evalForm.status!='VALID'">Submit Evaluation</button>
    </form>
  </ng-container>
</ng-container>

<ng-template #loading>
  <app-load-indicator description="load your evaluation questions"></app-load-indicator>
</ng-template>
